export const colors = {
  white: '#ffffff',
  black: '#000000',
  magenta: '#ee1f99',
  aqua: '#13f3f1',
  gray: 'ffffff99',
};

const styles = {
  line: {
    main: colors.magenta,
    secondary: colors.aqua,
  },
  text: {
    main: colors.white,
    secondary: colors.gray,
    detail: colors.gray,
  },
  background: {
    main: colors.black,
  },
  button: {
    main: {
      gradient: {
        start: '#dd1d7d',
        end: '#bd37ff',
      },
      shadow: '#ff0cae',
      border: '#f66596',
      text: colors.white,
    },
    secondary: {
      border: colors.white,
      text: colors.white,
    },
  },
  spinner: colors.magenta,
};

export default styles;
